import { render, staticRenderFns } from "./Badge.vue?vue&type=template&id=8a1d16de&"
import script from "./Badge.vue?vue&type=script&lang=js&"
export * from "./Badge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a1d16de')) {
      api.createRecord('8a1d16de', component.options)
    } else {
      api.reload('8a1d16de', component.options)
    }
    module.hot.accept("./Badge.vue?vue&type=template&id=8a1d16de&", function () {
      api.rerender('8a1d16de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/utils/Badge/Badge.vue"
export default component.exports